import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Icon } from '../Icon';
import { Text } from '../Text';
export function Fact({ icon, text, style }) {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(Icon, { name: icon, size: 28, color: (c) => c.primary.solid }),
        React.createElement(Text, { type: 'body', size: 'lg', weight: 'regular', style: styles.text }, text)));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        borderWidth: 1,
        borderColor: color.invert2.p4,
        borderRadius: size.G,
        padding: size.G
    },
    text: { marginTop: size.C }
}));
//# sourceMappingURL=index.js.map